module.exports = __webpack_public_path__ + "img/通知公告.jpg";